/**
 * Verifica se o usuário tem acesso ao dashboard
 * Apenas usuários com is_owner = 1 ou is_super_admin = 1 têm acesso
 *
 * @param userData - Dados do usuário (pode estar em session.user.user ou session.user)
 * @returns true se o usuário tem acesso ao dashboard, false caso contrário
 */
export function hasDashboardAccess(userData: any): boolean {
  if (!userData) {
    return false;
  }

  // Verificar is_owner (aceita boolean, number 1/0, ou string "1"/"0")
  const isOwnerValue = userData.is_owner;
  const isOwner =
    isOwnerValue === true || isOwnerValue === 1 || isOwnerValue === "1";

  // Verificar is_super_admin (aceita boolean, number 1/0, ou string "1"/"0")
  const isSuperAdminValue = userData.is_super_admin;
  const isSuperAdmin =
    isSuperAdminValue === true ||
    isSuperAdminValue === 1 ||
    isSuperAdminValue === "1";

  return isOwner || isSuperAdmin;
}

/**
 * Obtém os dados do usuário de uma sessão ou token
 *
 * @param sessionOrToken - Sessão do NextAuth ou token JWT
 * @returns Dados do usuário ou null
 */
export function getUserData(sessionOrToken: any): any {
  if (!sessionOrToken) {
    return null;
  }

  // Se for uma sessão
  if (sessionOrToken.user) {
    return sessionOrToken.user.user || sessionOrToken.user;
  }

  // Se for um token JWT
  if (sessionOrToken.data) {
    return sessionOrToken.data.user?.user || sessionOrToken.data.user;
  }

  return null;
}
